import { defaultEventCategorySet } from '@demind-inc/core';
import { TaskLabel } from '@demind-inc/core';

export const schedulableLabels = defaultEventCategorySet.filter(
  (item) => item.id && ['default_deepWork', 'default_lightTask'].includes(item.id)
);

export const canLabelBeScheduled = (label: string) => {
  return schedulableLabels.some((l) => l.name === label);
};

export const getDefaultLables = (labelGroupId: string): TaskLabel[] => [
  {
    name: 'Deep Work',
    id: `${labelGroupId}_default_deepWork`,
    color: '#8B0000', // dark red
  },
  {
    name: 'Light Task',
    id: `${labelGroupId}_default_lightTask`,
    color: '#4169E1', // royal blue
  },
  {
    name: 'Social',
    id: `${labelGroupId}_default_social`,
    color: '#228B22', // forest green
  },
  {
    name: 'Meeting',
    id: `${labelGroupId}_default_mtg`,
    color: '#FFD700', // gold
  },
  {
    name: 'Exercise',
    id: `${labelGroupId}_default_exercise`,
    color: '#FF8C00', // dark orange
  },
  {
    name: 'Break',
    id: `${labelGroupId}_default_break`,
    color: '#FF69B4', // hot pink
  },
  {
    name: 'Meal',
    id: `${labelGroupId}_default_meal`,
    color: '#9370DB', // medium purple
  },
  {
    name: 'Other',
    id: `${labelGroupId}_default_other`,
    color: '#32CD32', // light sea green
  },
];
